export default __webpack_public_path__ + "static/clean-7d1e632c45623104abe4df25f571f073.png";